
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 5.5a2.309 2.309 0 00-1.5 2v2h15v-2a2.308 2.308 0 00-1.5-2A2.5 2.5 0 0021.5 3 2.5 2.5 0 0019 .5H7a2.5 2.5 0 000 5v0zm2.176 1.294l3.5-3.5m1 3.5l3.5-3.5M4.5 9.5h17a2 2 0 012 2v11a1 1 0 01-1 1h-19a1 1 0 01-1-1v-11a2 2 0 012-2v0zm-3 2h1v3h-1a1 1 0 01-1-1v-1a1 1 0 011-1v0z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.5 20.5a2 2 0 100-4 2 2 0 000 4zm0-6v-1m3 5h-1","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    